import React, { useMemo } from "react";
import { observer } from "mobx-react-lite";
import { useGetFolderLevelPermission } from "@webiny/app-aco";
import { PageListConfig } from "~/admin/config/pages";
import { usePagesPermissions } from "~/hooks/permissions";
import { ActionUnpublish as ActionUnpublishBase } from "~/admin/components/BulkActions";

export const SecureActionUnpublish = observer(() => {
    const { canUnpublish } = usePagesPermissions();
    const { getFolderLevelPermission: canManageContent } =
        useGetFolderLevelPermission("canManageContent");

    const { useWorker } = PageListConfig.Browser.BulkAction;

    const worker = useWorker();

    const canUnpublishAll = useMemo(() => {
        return worker.items.every(item => {
            return canUnpublish() && canManageContent(item.location?.folderId);
        });
    }, [worker.items, canManageContent]);

    if (!canUnpublishAll) {
        console.log("You don't have permissions to unpublish pages.");
        return null;
    }

    return <ActionUnpublishBase />;
});
